import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import * as _ from 'lodash';
import { DocmanFileModel } from '../services/docman.model.file';
import { DocmanFolderModel } from '../services/docman.model.folder';
import { UiService } from '../../../core/services/core.ui.service';

@Component({
  selector: 'file-organizer-modal',
  template: require('./file.organizer.modal.html')
})
export class FileOrganizerModalComponent implements OnInit {
  @Input() file: any;
  @Input() project: any;

  @Output() onSave: EventEmitter<any> = new EventEmitter<any>();
  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();

  foldersFile: any[] = [];

  constructor(
    private docmanFileModel: DocmanFileModel,
    private docmanFolderModel: DocmanFolderModel,
    private uiService: UiService
  ) {}

  ngOnInit() {
    this.docmanFileModel.getFileDetails(this.file.docmanFile.id)
      .then(response => {
        this.foldersFile = [this.docmanFolderModel.getFolderOrganizerList(response.rel.folders, this.project)];
      })
      .catch(() => {
        this.uiService.message.showError(`There was an error loading folders for ${_.get(this.file, 'description', '(unknown)')}`);
        this.onClose.emit();
      });
  }

  save() {
    let success = false;
    let folders: any[] = [];
    const fileSave = _.cloneDeep(this.file.docmanFile);

    folders = this.docmanFileModel.getAssignedFolders(folders, this.foldersFile[0]);
    fileSave.rel = {
      folders: folders
    };

    this.docmanFileModel.saveFileSettings(fileSave)
      .then(() => {
        success = true;
        this.uiService.message.showSuccess(`File settings for ${_.get(this.file, 'description', '(unknown)')} have been updated successfully`);
        this.onSave.emit({success: true});
      }, () => {
        this.uiService.message.showError(`There was an error updating ${_.get(this.file, 'description', '(unknown)')}`);
        this.onClose.emit();
      });
  }
}
